const defaultReturn = data => data;

export default defaultReturn;
